import { Component, OnInit,Injector, ElementRef } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import moment from 'proxies/dayjs';
import { DownloadService } from 'src/modules/base/shared/services/download.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';

@Component({
    selector: 'app-advance-mis',
    templateUrl: './advance-mis.component.html',
    standalone: false
})
export class AdvanceMisComponent implements OnInit {
  headerList: any;
  dataProcessed: boolean;
  configList: any;
  headers: any;
  dataList: any;
  u_id:any;
  current_Resource: any;
  date = new Date();
  pageSize: any;
  pageNumber: any;
  arch_Data:any;
  filterDate = new Date();
  banner: any;
  fields: any;
  currentTab: any = 'all';
  newDataList: any;
  type: any;
  callGRID: boolean = false;
  callSummary: boolean = true;
  response_type:any;
  apiResource: any;
  response: any;
  userName: any;
  resource__:any;
  filterList: any;
  dynamicHeaders: any = [];
  config: any;
  selectedFilter: any;
  showGrid: boolean = true;
  filter: any;
  filterPrintInfo:any;
  amountData: any; specailValues: any=[];
  _currentData: any = {};
  parent_id: any;
  resourcename: any;
  activatedRoute: any;
  storageService: any;
  public preferenceService: PreferenceService;
  searchLabel: any;
  search_columns :any;
  searchColumns :any;
  searchs: any;

  constructor(public injector: Injector, private baseService: BaseService, private router: Router, private route: ActivatedRoute, private loader: LoaderService, private alertService: AlertsService, private printService: PrintService, public rolePermissionService: RolePermissionService, public appService: AppService, public alerts: AlertsService, private location: Location,   public downloadService: DownloadService) { 
    this.preferenceService = injector.get(PreferenceService);
  }

  ngOnInit() {

    if(this.route.snapshot.queryParams.tab_0)
    sessionStorage.removeItem("datefilter");
    this.u_id=JSON.parse(localStorage.currentUser).user_id;
    console.log("routee", this.route);
    this.current_Resource = localStorage.CurrentResource;

    this.baseService.getResourceDef(this.current_Resource, (res) => {
      this.loader.showSpinner();
      if (res != undefined) {
        if (res.page_name)
          this.baseService.setTitle(res.page_name.list);
        this.response = res;
        if (res) {
          this.checkIfArchiveAvailable(res);}
        this.type = this.response.type;
        this.userName = JSON.parse(localStorage.currentUser);
        this.route_api()
        if (this.route.snapshot != undefined && this.route.snapshot.data != undefined && this.route.snapshot.data.resource != undefined && this.route.snapshot.data.resource == 'collection_detail_format_old') {
          this.baseService.getResourceDef('user_wise_collection', (res) => {
            if (res != undefined) {
              this.config = res;
              this.header_club()
              this.loader.hideSpinner();
            }
          })
        }
        if (this.route.snapshot != undefined && this.route.snapshot.params != undefined && this.route.snapshot.params.resource != undefined && this.route.snapshot.params.resource == 'mis_advance_and_consume_reports') {
          this.baseService.getResourceDef('user_wise_collection', (res) => {
            if (res != undefined && res.archiveConfig.list[0].id== "Default") {
              if (res.printActions && res.printActions.length > 0 && this.current_Resource == "mis_uhid_advance") {
                res.printActions.forEach(element => {
                  element.file_data.query_id = 'MIS_ADVANCE'
                });
              }
              if (res.printActions && res.printActions.length > 0 && this.current_Resource == "mis_advance") {
                res.printActions.forEach(element => {
                  element.file_data.query_id = 'MIS_ADVANCE'
                });
              }
              // if (res.printActions && res.printActions.length > 0 && this.current_Resource == "cashier_user_wise") {
              //   res.printActions.forEach(element => {
              //     element.file_data.query_id = 'GET_CASHIER_COLLECTION_SUMMARY'
              //   });
              // }
              // if (res.printActions && res.printActions.length > 0 && this.current_Resource == "cashier_collection_detail") {
              //   res.printActions.forEach(element => {
              //     element.file_data.query_id = 'GET_USER_WISE_COLLECTION_DETAIL'
              //   });
              // }
              this.config = res;
              this.header_club()
              this.loader.hideSpinner();
            }
          })
        }
      }
    })
    this.uiInit();
  }
  uiInit(config?) {
    if (!this.parent_id) {
      this.parent_id = 0;
    }

    if (this._currentData.origArhiveConfig == undefined) {
      this.initCurrentData();
      if (config && config["archiveConfig"] != undefined) {
        this._currentData["archiveConfig"] = {};
        this._currentData["archiveConfig"]["selected"] = config["archiveConfig"];
        this._currentData["archiveConfig"]["applied"] = true;
        this._currentData.dataGridConfig = {};
        this._currentData.gridData.page_no = 0;
        
      } else {
        //if its archive old filter and page number is not needed bevause we may not support the applied filters on archive data
        this._currentData.loadSavedFilter = true;
        if (this.route.snapshot.queryParams["p__no"] != undefined) {
          this._currentData.gridData.page_no = parseInt(this.route.snapshot.queryParams["p__no"])
        }
      }
      if (this.resourcename) {
        this._currentData.resource = this.resourcename;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.data.resource != undefined) {
        this._currentData.resource = this.route.snapshot.data.resource;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.paramMap.get('resource') != null) {
        this._currentData.resource = this.route.snapshot.paramMap.get('resource');
        this._currentData.json = this.route.snapshot.paramMap.get('resource');
      }
      if (this.route.snapshot.data.view != undefined && this.route.snapshot.data.view) {
        this._currentData.view = this.route.snapshot.data.view;
        this._currentData.json = this._currentData.view;
      }
    } else {
      //archive is loading
      var origArhiveConfig = JSON.parse(JSON.stringify(this._currentData.origArhiveConfig));
      this.initCurrentData();
      this._currentData.origArhiveConfig = origArhiveConfig;
      this._currentData.json = this._currentData.origArhiveConfig.resource;
    }
    this._currentData.bookmarks = undefined;
    // if (this.route.snapshot != undefined && this.route.snapshot.params != undefined && this.route.snapshot.params.resource != undefined && this.route.snapshot.params.resource == 'mis_advance_and_consume_reports') {
    //   this.baseService.getResourceDef('user_wise_collection', (res) => {
    //     if (res != undefined) {
    //       this.config = res;
    //       this.header_club()
    //     }
    //     })
    //   }
  }
  checkIfArchiveAvailable(resourceDef) {
    this.callGRID=false;
    if (resourceDef.config != undefined && resourceDef.config.archiveConfig != undefined) {
      var selected = false;
      var applied = false;
      if (this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined) {
        selected = this._currentData.archiveConfig.selected;
        applied = true;
      }
      this._currentData["archiveConfig"] = resourceDef.config.archiveConfig


      if (this.arch_Data && this.arch_Data.download_only) {
        this._currentData["archiveConfig"]["selected"] = this._currentData["archiveConfig"]["list"][1];
      } else {
        this._currentData["archiveConfig"]["selected"] = this._currentData["archiveConfig"]["list"][0];
      }
      this._currentData["archiveConfig"]["applied"] = applied;

      /************* START REMOVING FILTER *************/
      if (this._currentData["archiveConfig"].limit_filter != undefined && this._currentData["archiveConfig"].limit_filter) {
        this.removeFilterForArchive(this.response["archive this.loader.showSpinner();"], resourceDef);
      }
      /************* STOP REMOVING FILTER *************/

    }
  }
  initCurrentData() {
    this._currentData = {
      'addAllowed': true,
      'config': {
        'activeField': 'table',
        'tile': false,
        'table': true,
      },
      'dataList': [],
      'filterList': [],
      'gridData': {},
      "showBanner": false,
      "customClick": false,
      "render_template": true,
      "tabClick": false,
      'showView': false,
      "showAddButton": true,
      "bulkAction": false,
      "currentListFields": [],
      "cardHeader": {},
      "defaultFormData": {},
      "currentFormFields": {},
      "foreignKeyData": {},
      "decorator": false,
      "filterDecorator": false,
      "default_filter": false,
      "ruleEngine": {}
    }
    this._currentData.renderView = true;
    this._currentData.currentFormFields.loaded = false;
  }

  removeFilterForArchive(archiveConfig, resourceDef) {
    try {
      if (resourceDef.list != undefined && resourceDef.list.filter != undefined && Array.isArray(resourceDef.list.filter.blocks[0].fields)) {
        var selected = this._currentData["archiveConfig"]["selected"];
        var defaultFilter = this._currentData["archiveConfig"]["list"][0];

        for (let i = resourceDef.list.filter.blocks[0].fields.length - 1; i >= 0; i--) {
          let singleField = resourceDef.list.filter.blocks[0].fields[i];
          switch (singleField.component) {
            case "daterangepicker":
              if (this._currentData["archiveConfig"].FROMTOKEY != undefined && this._currentData["archiveConfig"].FROMTOKEY == singleField.name) {
                delete singleField.minDateNumber;
                delete singleField.minDateUnit;
                delete singleField.maxDateNumber;
                delete singleField.maxDateUnit;
                delete singleField.maxSpan;
                delete singleField.forceEndOfDay;
                if (selected.minDateNumber != undefined) {
                  if (this.appService.getArchiveConfigs()[selected.minDateNumber] != undefined) {
                    singleField.minDateNumber = this.appService.getArchiveConfigs()[selected.minDateNumber];
                    singleField.minDateUnit = "days";
                  } else {
                    this.alerts.error("field.label.Invalid_Input");
                    console.error("Archive config not correct:minDateNumber", selected)
                  }

                }
                if (selected.maxDateNumber != undefined) {
                  if (this.appService.getArchiveConfigs()[selected.maxDateNumber] != undefined) {
                    singleField.maxDateNumber = this.appService.getArchiveConfigs()[selected.maxDateNumber] * -1;
                    singleField.maxDateUnit = "days";
                  } else {
                    this.alerts.error("field.label.Invalid_Input");
                    console.error("Archive config not correct:maxDateNumber", selected)
                  }
                }
                if (selected.maxSpan != undefined) {
                  singleField.maxSpan = selected.maxSpan;
                }
                if (selected.forceEndOfDay != undefined) {
                  singleField.forceEndOfDay = selected.forceEndOfDay;
                }
                if (selected.id != defaultFilter.id) {//default datasource is not there add it as required
                  singleField.required = true;
                }
              }
              break;
            default:
              break;
          }
          if (selected.id != defaultFilter.id) {//default datasource is not there removing extra filters
            if (singleField.filters != undefined && singleField.filters.indexOf(selected.id) > -1) {
              if (["daterangepicker"].indexOf(singleField.component) > -1) {
                delete singleField.selected;
              }
            } else {
              resourceDef.list.filter.blocks[0].fields.splice(i, 1);
            }
          }
        }
      }
    } catch (e) {

    }

  }

  route_api() {
    let patientData = JSON.parse(sessionStorage.getItem('currentData'));
    let start = moment().startOf('day').valueOf();
    let end = moment().endOf('day').valueOf();
    this.route.queryParams.subscribe(data => {
      if (sessionStorage.currentData) {
        if (this.current_Resource == 'mis_uhid_advance') {
          this.selectedFilter = 'deposit_for:UHID'} 
        if (data.hasOwnProperty('breakup') && ((this.current_Resource != 'mis_uhid_advance' || this.current_Resource != 'mis_advance' ))) {
          this.selectedFilter = 'deposit_for:UHID'
        }
      }
      else {
        if ((this.response.list.filter || this.response.filter) && ((this.current_Resource == 'mis_uhid_advance' || this.current_Resource == 'mis_advance' ))) {
          this.selectedFilter = 'deposit_for:UHID'
        }
      }
      if (this.selectedFilter == undefined) {
        this.selectedFilter = "FROMTOKEY:" + "g_creation_time" + ",FROM:" + start + ",TO:" + end
      }
      else {
        if(this.current_Resource=="mis_uhid_advance"){
          this.selectedFilter = this.selectedFilter+",FROMTOKEY:" + "g_creation_time" + ",FROM:" + start + ",TO:" + end
        }
        else{
        this.selectedFilter = "FROMTOKEY:" + "g_creation_time" + ",FROM:" + start + ",TO:" + end
        }
      }
      if (this.route.snapshot.data.hasOwnProperty('type')) {
        this.type = this.route.snapshot.data.type;
        if (this.type == 'detailed_breakup') {
          this.current_Resource = 'mis_uhid_advance';
        }
        else if (this.type == 'summary_breakup') {
          this.current_Resource = 'mis_uhid_advance';
        }
      }
      console.log("this.route.queryParams", this.selectedFilter)
    })
  }
  getConfigValues(event) {
    this.arch_Data=event.archiveConfig;
    if (event.changePage != undefined) {
    this._currentData.gridData.page_no = event.changePage;
    this.callGRID=true
  }
  else if (event.filterPrintInfo) {
    this.filterPrintInfo = event.filterPrintInfo
  }
    else if (event.archiveConfig != undefined) {
      this.callGRID=false
      if(event.archiveConfig.forceEndOfDay){
      this.callSummary = false}
      this._currentData = false;
      setTimeout(() => {
        this._currentData = {};
        this.ngOnInit();
      })
    }
    else if (event.configureGrid != undefined) {
      this.configUIEngine(event.configureGrid);
    }
    // this.getAmountApiCall();
  }
  configUIEngine(config) {
    var obj: any = {};
    obj = { ...obj, ...config };
    obj["key"] = this.getConfigurationKey(config);
    obj["resource_name"] = this._currentData.json;
    if (config.context == 'grid') {
      obj["resource_name"] = this.current_Resource;
    }
    this.preferenceService.openConfigurePopup(obj, (response) => {
      if (response.result != undefined) {

        this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
          console.log(result);
        });



      }
    });
  }
  getConfigurationKey(config) {
    var resourceName = this._currentData.json;
    if (config.context == 'grid') {
      resourceName = this.current_Resource;
    }
    return this.preferenceService.getConfigurationKey(resourceName);
  }
  goBack() {
    this.location.back(); //going back location
  }
  header_club() {
    this.headers = this.config.headers;
    //this.customButton = this.config.customButton;
    this.configList = {
      "save_filter":true,
      "customButton": this.config.customButton,
      "viewAll": true,
      "hideSearchBox": true,
      "hideResult": true,
      "resource": this.current_Resource
    }
    if(this.current_Resource == "mis_uhid_advance")
    {
      this.configList = {
        "save_filter": true,
        "customButton": this.config.customButton,
        "viewAll": true,
        "archiveConfig":this.config.archiveConfig,
        "hideSearchBox": false,
        "projectionKeys": this.config.projectionKeys,
        "complex_search": this.config.complex_search,
        "allowPagination": true,
        "resource": this.current_Resource
      }
    }
    if(this.current_Resource == "mis_advance")
    {
      this.configList = {
        "save_filter": true,
        "customButton": this.config.customButton,
        "viewAll": true,
        "hideSearchBox": false,
        "complex_search": this.config.complex_search,
        "projectionKeys": this.config.projectionKeys,
        "archiveConfig":this.config.archiveConfig,
        "allowPagination": true,
        "resource": this.current_Resource
      }
    }
    // if (this.isDownloadOnly()) {
    //   this.callGRID = true;
    //   this.loader.hideSpinner();
    //   return ;//no API call is needed since only download of the data is allowed
    // }
    if(this.configList && this.configList.archiveConfig)
    this.configList.archiveConfig['selected']=this._currentData["archiveConfig"]["selected"];
    // this.baseService.get('GET_BY_ID', 'id:' + this.userName.user_id, 'account_user', 'account-management').subscribe(userData => {
    //   console.log("userData", userData)
    //   // this.userName = userData.resource[0]
    // })
    if (this.current_Resource) {
      if (this.current_Resource == 'mis_uhid_advance') {
        if (this.type != 'detailed_breakup') {
          this.type = 'cashier_advance';
        }
        this.baseService.init("mis_uhid_advance");
      }
      if (this.current_Resource == 'mis_advance') {
        if (this.type != 'detailed_breakup') {
          this.type = 'cashier_advance';
        }
        this.baseService.init("mis_advance");
      }
      // if (this.current_Resource == 'user_collection_summary_old' || this.current_Resource == 'user_collection_summary'
      // ) {
      //   if (this.type != 'detailed_breakup') {
      //     this.type = 'summary';
      //   }
      //   this.baseService.init("user_collection_summary");
      // }
      // if (this.type == 'detailed_breakup') {
      //   this.baseService.init('user_collection_detail_old');
      // }
      // else if (this.type == 'summary_breakup') {
      //   this.baseService.init('user_collection_summary');
      // }
      // else {
      //   this.baseService.init(this.current_Resource);
      // }
    }
    // if (this.route.snapshot.data.hasOwnProperty('type'))
    //   this.type = this.route.snapshot.data.type
    // if (this.type == 'summary') {
    //   this.baseService.init("user_collection_summary");
    // }
    // if (this.type == 'detail') {
    //   this.apiResource = this.config[this.type]
    //   this.configList.hideSearchBox = false;
    //   this.configList.complex_search = this.config.complex_search
    // }
    // if (this.type == 'collection_detail') {
    //   this.baseService.init("cashier_collection_detail");
    // }
    this.apiResource = this.config[this.type]
    // if (this.type == 'detail' || this.type == 'summary') {
      if(this.apiResource )
    var obj = { filter: this.selectedFilter ? this.selectedFilter : "", page_size: 10, query_id: this.apiResource.queryId,projectionKeys: this.config.projectionKeys}
    if(this.configList.archiveConfig.selected.label=="cur_data"){
      this.configList.allowConfigGrid=true;
    this.baseService.get('GET_HEADERS', '', 'user_collection_summary', 'misreports').subscribe(response => {
      this.headerList = response.resource;
      this.baseService.getResourceDef(this.current_Resource, (resouceDef) => {
        // if (resouceDef) {
        let entry;
        let entry1;
        this.headerList.forEach(data => {
          this.dynamicHeaders.push(data.name);
          this.dynamicHeaders.push(data.name+"payment_reciept_no");
          entry = {
            heading: data.label,
            order: resouceDef.list.fields.length + 1,
            name: data.name,
            disabled: false,
            hidden: false,
            selected: true
          }
          entry1 = {
            heading: data.type,
            order: resouceDef.list.fields.length + 1,
            name: data.name+"payment_reciept_no",
            disabled: false,
            hidden: false,
            selected: true
          }
          this.specailValues.push(entry1.name);
          resouceDef.list.fields.push(entry);
          resouceDef.list.fields.push(entry1);
        });
        if (resouceDef && resouceDef.list && resouceDef.list.fields) {
          resouceDef.list.fields.sort((a, b) => { return a.order - b.order });
        }
        this.fields = resouceDef.list;
        console.log("this.fields = " ,this.fields);
        this.filterList = { blocks: resouceDef }
      })
      
      this.baseService.getData(obj, "", this.apiResource.dataResource ? this.apiResource.dataResource : this.apiResource.resource, this.apiResource.application).subscribe(
        (data: any) => {
          if (this.fields) {
            if (this.fields.amountResource) {
              this.fields['resFromGrid'] = data;
              this.fields.amountCall = false;
        
              if (data.search != undefined && data.search) {
                this.fields['hideViewSummary'] = true;
              }
              else {
                this.fields['hideViewSummary'] = false;
              }
            } 
          }
          if (this.fields.amountResource && this.fields.amountResource.datasource)
            this.getAmountApiCall()
          console.log("dtata ->", data)
          if (data.resource != undefined) {
            data.resource.forEach(element => {
              this.headerList.forEach(header => {
                element[header.name] = 0;
              });
              if (element.payment_detail) {
                element.payment_detail.forEach(subelement => {
                  if (subelement.payment_mode_code != "")
                    element[subelement.payment_mode_code] = subelement.amount
                    if (subelement.payment_mode_code != "")
                    element[subelement.payment_mode_code+"payment_reciept_no"] = subelement.payment_reciept_no  
                });
              }
            })
          }

          this.newDataList = data;
          console.log("this.newDataList",this.newDataList);
          this.loader.hideSpinner();
          this.uiInit();
          this.callGRID=true;
        }, err => {
          this.loader.hideSpinner();
        })
    })
  }
  else{
    this.isDownloadOnly();
  }
    this.uiInit();
    // }
    // if (this.type == 'cashier_advance') {
    //   console.log('cashier_advance')
    // }
  }
  getAmountInfo()
  {
    this.loader.showSpinner();
    this.fields.amountCall = true;
    this.getAmountApiCall(this._currentData['resFromGrid']); 
  }
  getFilterLabel() {
    console.log("========getFilterLabel===============");
    if (this.persistGrid()) {
      try {
        var snapshot = this.activatedRoute.snapshot;
        var filterSaveKey = "f__k";
        var params = { ...snapshot.queryParams };
        if (params[filterSaveKey] != undefined && params[filterSaveKey]) {
          var filterObj = this.storageService.getSessionStorageDataSync(filterSaveKey + "_" + this._currentData.resouceDef.resource);
          if (filterObj) {
            if (filterObj["key"] != undefined && filterObj["key"] == params[filterSaveKey]) {
              return filterObj;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }

  }
  persistGrid() {
    if (this._currentData.origArhiveConfig != undefined) {
      return false;
    }
    if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
      return false;
    }
    return (this.constructor.name.toLowerCase() == "uienginecomponent");
  }
  activeTab(key) {
    this.showGrid = false;
    this.loader.showSpinner();
    let obj = { filter: "", page_size: 10, query_id: this.apiResource.queryId }
    this.currentTab = key;
    this.newDataList = undefined;
    if (this.currentTab != 'all') {
      // if (this.type == 'detail')
      //   obj.filter = "patient_type:" + this.currentTab
      // else
      // if (this.current_Resource != 'mis_uhid_advance' ) {
      //   obj.filter = "patientType:" + this.currentTab + ",userId:" + this.u_id
      // }
      // else {
      //   obj.filter = "patientType:" + this.currentTab
      // }
    }
    // else {
    //   if (this.current_Resource != 'mis_uhid_advance') {
    //     obj.filter = "userId:" + this.u_id
    //   }
    // }
    this.selectedFilter = obj.filter;

    this.baseService.getData(obj, "", this.apiResource.resource, this.apiResource.application).subscribe(
      (data: any) => {
        console.log("dtata ->", data)
        if (data && data.resource && data.resource.length > 0) {
          data.resource.forEach(element => {
            this.headerList.forEach(header => {
              element[header.name] = 0;
            });
            if (element.payment_detail) {
              element.payment_detail.forEach(subelement => {
                if (subelement.payment_mode_code != "")
                  element[subelement.payment_mode_code] = subelement.amount;
                if (subelement.payment_mode_code != "")
                  element[subelement.payment_mode_code+"payment_reciept_no"] = subelement.payment_reciept_no  
              });
            }

          })
        }
        this.newDataList = data;
        this.loader.hideSpinner();
      },
      err => {
        this.loader.hideSpinner();
      })
    setTimeout(() => {
      this.showGrid = true;
    })
    //   if(this.current_Resource == 'mis_uhid_advance' )
    //    {
    //          let start = moment().startOf('day').valueOf();
    //     let end = moment().endOf('day').valueOf();
    //     this.selectedFilter="FROMTOKEY:" + "transaction_date_time" + ",FROM:" + start + ",TO:" + end +",patientType:" + this.currentTab +",userId:" + this.u_id;
    //     this.getAmountApiCall();
    // }
    // if(this.current_Resource=="mis_uhid_advance" )
    //    {
    //          let start = moment().startOf('day').valueOf();
    //     let end = moment().endOf('day').valueOf();
    //     this.selectedFilter="FROMTOKEY:" + "transaction_date_time" + ",FROM:" + start + ",TO:" + end +",patientType:" + this.currentTab
    //     // else {
    // //   if (this.current_Resource != 'mis_uhid_advance') {
    // //     obj.filter = "userId:" + this.u_id
    // //   }
    // // } this.getAmountApiCall();
    // }
  }

  getAmountApiCall(event?) {
    this.callGRID=false
    this.callSummary = true
    let obj = {filter: event ? event : this.selectedFilter, page_size: this.pageSize != undefined ? this.pageSize : 10, page_no: this.pageNumber >= 0 ? this.pageNumber : "", query_id: this.fields.amountResource.datasource.query_id,search_columns: this.search_columns, searchColumns: this.searchColumns , search: this.searchs, searchLabel: this.searchLabel}
    this.applyArchivePoicy(obj, true);
    //this.isDownloadOnly();
    this.baseService.getData(obj, "", this.fields.amountResource.datasource.resource, this.fields.amountResource.datasource.application).subscribe(
      (data: any) => {
        if (data.errCode == 0) {
          let arr = [];
          if (this.fields.amountResource.datasource.mapKey != undefined && this.fields.amountResource.datasource.type != "multiple") {
            let s = data.resource[0][this.fields.amountResource.datasource.keys]
            this._currentData.amountData = Object.keys(s).map(x => { return { key: x, value: s[x] } })
            this._currentData.amountCall = true;
            this._currentData.dynamic_keys = true;
          } 
          else if (this.fields.amountResource.datasource.keys) {
            this._currentData.amountCall = true;
            let resp = this.fields.amountResource.datasource.keys[0];
            if (data.resource && data.resource.length > 0) {
              Object.keys(resp).forEach(function (key) {
                let item = data.resource[0]
                let obj = {};
                obj['key'] = key;
                obj['value'] = data.resource[0][resp[key]] == undefined ? eval(resp[key])(item) : data.resource[0][resp[key]];
                arr.push(obj);
              });
            }
            this._currentData.headerKey= obj['key'] 
            this._currentData.headerKey= obj['value']
            this._currentData.amountData= arr;
          }
          //   else if (this.fields.amountResource.datasource.keys != undefined && this.fields.amountResource.datasource.type == "multiple") {
          //   this._currentData.amountCall = true;
          //   let s = this.fields.amountResource.datasource.keys
          //   Object.keys(s).map(x => { return { key: x, value: s[x] } }) 
          //   let y= data.resource[0]
          //   this._currentData.amountData = Object.keys(y).map(x => { return { key: x, value: s[x] } })           
          //  }
          // } else {
          //   this._currentData.dynamic_keys = true;
          //   this.getDataAmount(this.fields.amountResource.datasource.keys, data, arr, () => { })
          // }
          this.loader.hideSpinner();
        } else {
          this.loader.hideSpinner();
          // this.alertService.error(data.message)
        }
      }, err => {
        this.loader.hideSpinner();
      }
      )
  }

  // getDataAmount(resp, data, arr, callback) {
  //   if (data.resource && data.resource.length > 0) {
  //     let item = data.resource[0];
  //     if (resp == 'multiple') {
  //       arr = data.resource;
  //     } else if (typeof (resp) == 'object' && !Array.isArray(resp)) {
  //       Object.keys(resp).forEach(function (key) {
  //         let obj = {};
  //         obj['key'] = key;
  //         obj['value'] = item[resp[key]] == undefined ? eval(resp[key])(item) : item[resp[key]];
  //         arr.push(obj);
  //       });
  //     } else {
  //       Object.keys(resp).forEach(function (key) {
  //         let obj = {};
  //         obj['key'] = key;
  //         obj['value'] = item[resp[key]] == undefined ? eval(resp[key])(item) : item[resp[key]];
  //         arr.push(obj);
  //       });
  //     }
      
  //       this._currentData.amountData = arr;
  //       this._currentData.amountCall = true;
  //   }
  // }
  
  isDownloadOnly() {
    this.callGRID=true;
    if (this._currentData != undefined && this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined && this._currentData.archiveConfig.selected.download_only != undefined && this._currentData.archiveConfig.selected.download_only) {
      return true;
    }
    return false;
  }
  // getDataAmount(resp, data, arr, callback) {
  //   if (data.resource && data.resource.length > 0) {
  //     let item = data.resource[0];
  //     if (resp == 'multiple') {
  //       arr = data.resource;
  //     } else if (typeof (resp) == 'object' && !Array.isArray(resp)) {
  //       Object.keys(resp).forEach(function (key) {
  //         let obj = {};
  //         obj['key'] = key;
  //         obj['value'] = item[resp[key]] == undefined ? eval(resp[key])(item) : item[resp[key]];
  //         arr.push(obj);
  //       });
  //     } else {
  //       resp.map((object) => {
  //         let obj = {};
  //         obj['key'] = Object.values(object)[0],
  //           obj['value'] = Object.values(object)[1]
  //         arr.push(obj);
  //       });
  //     }
  //     if (callback) {
  //       callback(arr);
  //     } else {
  //       this._currentData.amountData = arr;
  //       this._currentData.amountCall = true;
  //     }
  //   }
  // }

  limitChanged(event) {
    this.pageNumber = 0;
    this.pageSize = event.target.value;
    this.bindGrid();
  }
  bindGrid() {
    let obj = { filter: this.selectedFilter ? this.selectedFilter : "", page_size: this.pageSize != undefined ? this.pageSize : 10, page_no: this.pageNumber >= 0 ? this.pageNumber : "", query_id: this.apiResource.queryId }
    this.baseService.getData(obj, "", this.apiResource.dataResource ? this.apiResource.dataResource : this.apiResource.resource, this.apiResource.application).subscribe(
      (data: any) => {
        console.log("dtata ->", data)
        data.resource.forEach(element => {
          this.headerList.forEach(header => {
            element[header.name] = 0;
          });
          if (element.payment_detail) {
            element.payment_detail.forEach(subelement => {
              if (subelement.payment_mode_code != "")
                element[subelement.payment_mode_code] = subelement.amount
              if(subelement.payment_mode_code != "")  
                element[subelement.payment_mode_code+"payment_reciept_no"] = subelement.payment_reciept_no
            });
          }
        })
        this.newDataList = data;
        this.loader.hideSpinner();
      }, err => {
        this.loader.hideSpinner();
      })

  }
  pageChanges(event, resource?, application?, type?) {
    //this.apiResource.gridData.page_no = event - 1;
    this.pageNumber = event - 1;
    this.bindGrid();
  }
  bindDataToGrid(event) {
    this.callGRID=true;
    this.arch_Data=event.archiveConfig;
    this.loader.showSpinner();
    if(this._currentData.amountData && this.fields)
    {
      this.fields.amountCall = false;
      this._currentData.amountData = undefined;
    }
    // if(this.type == 'cashier')
    // {
    if (event) {
      console.log("here i am ", event)
      if (event.includes(',') && event.includes('FROMTOKEY')) {
        this.filter = event;
        console.log("filter:", this.filter);
      }
      if (event.includes(',') && event.includes('facility_id')) {
        let splitFilter = event.split(',')[2];
        this.filterDate = new Date(JSON.parse(splitFilter.split(':')[1]));
      }
      else if (event.includes(',') && !event.includes('facility_id')) {
        let splitFilter = event.split(',')[1];
        if (splitFilter.includes('FROM'))
          this.filterDate = new Date(JSON.parse(splitFilter.split(':')[1]));
      }
      else {
        if (event.includes('date')) {
          this.filterDate = new Date(JSON.parse(event.split(':')[1]));
        }
      }
      sessionStorage.setItem('datefilter',event.split('FROMTOKEY')[1])
    }
    else
      this.filterDate = new Date()

    let obj = { filter: event ? event : '', page_size: 10, query_id: this.apiResource.queryId }
    if (this.type == 'summary' || this.type == 'detail' || this.type == 'collection_detail') {
      if (this.currentTab != 'all') {
        if(obj.filter.includes('patientType') && !obj.filter.includes('userId'))
        obj.filter=obj.filter+",userId:" + JSON.parse(localStorage.currentUser).user_id
        else if(obj.filter.includes('patientType') && obj.filter.includes('userId'))
        obj.filter=obj.filter
        else
        obj.filter = (obj.filter != "" ? obj.filter + ",patientType:" + this.currentTab : "patientType:" + this.currentTab)
      }
    }
    // if((this.current_Resource=="mis_uhid_advance" ) && !obj.filter.includes('userId'))
    // this.selectedFilter = obj.filter+ ",userId:" + JSON.parse(localStorage.currentUser).user_id
    else if(this.current_Resource=="mis_advance"){
    this.selectedFilter = obj.filter
    }
    else{
      this.selectedFilter = obj.filter + ",deposit_for:UHID"
    }
    // }
    this.newDataList = undefined;
    if(event == undefined){
      if(this.current_Resource=="mis_advance" )
      obj.filter = this.baseService.buildDyanamicStr("FROMTOKEY:g_creation_time,FROM:!!!start_today!!!,TO:!!!end_today!!!","")+ ",patientType:" + this.currentTab
      else
      obj.filter = this.baseService.buildDyanamicStr("FROMTOKEY:g_creation_time,FROM:!!!start_today!!!,TO:!!!end_today!!!","")+ ",deposit_for:UHID"
    }
    else{
      obj.filter = this.selectedFilter
    }
    this.baseService.getData(obj, "", this.apiResource.dataResource ? this.apiResource.dataResource : this.apiResource.resource, this.apiResource.application).subscribe(
      (data: any) => {
        console.log("dtata ->", data)
        if (this.fields.amountResource && this.fields.amountResource.datasource) {
          var filters;
          if(this.fields.amountResource.datasource.filter != undefined && event == undefined){
            if(this.current_Resource=="mis_advance")
            filters = this.baseService.buildDyanamicStr(this.fields.amountResource.datasource.filter,"")+ ",patientType:" + this.currentTab+ ",deposit_for:UHID" 
            else
            filters = this.baseService.buildDyanamicStr(this.fields.amountResource.datasource.filter,"")+ ",deposit_for:UHID" 
          }else{
            if(this.current_Resource=="mis_advance")
            {
              filters = event
            }
            else
            {
              if(event.includes("patientType"))
              filters = event
              else
            filters = event + ",deposit_for:UHID" 
            }

          }

          this.getAmountApiCall(filters)
        }
        data.resource.forEach(element => {
          this.headerList.forEach(header => {
            element[header.name] = 0;
          });
          if (element.payment_detail) {
            element.payment_detail.forEach(subelement => {
              if (subelement.payment_mode_code != "")
                element[subelement.payment_mode_code] = subelement.amount
              if (subelement.payment_mode_code != "")
                element[subelement.payment_mode_code+"payment_reciept_no"] = subelement.payment_reciept_no  
            });
          }
        })
        this.newDataList = data;
      })
    setTimeout(() => {
      this.loader.hideSpinner();
    })
  }

//   changeStatus() {
//     this.baseService.action({ userId: this.userName.user_id }, 'UPDATE_USER_CLOSING_STATUS', 'payment', 'user_collection_summary').subscribe(data => {
//       if (data.errCode == 0)
//         this.alertService.success('Updated  Successfully.');
//     })
//   }
  ellipsfun(event) {
    if (event.actionType && event.actionType.action && event.actionType.action == "refresh") {
      this.bindGrid();
      return;
    }
    console.log("event is - ", event);
    let obj = {
      userId: event.data.userId,
      id: event.data.id
    }
    if (event.actionType.action == 'acknowledge')
      this.baseService.action(obj, 'ACKNOWLEDGE_STATUS', 'payment', 'user_collection_summary').subscribe(data => {
        console.log("data", data);
        if (data.errCode == 0)
          this.alertService.success('Updated Successfully.');
        this.bindGrid();
        (document.getElementsByTagName('popover-container')[0] as HTMLElement).style.display = 'none';
      })
    if (event.actionType.hasOwnProperty('redirectLink')) {
      sessionStorage.setItem("currentData", JSON.stringify(event.data))
      if (event.actionType.action == 'detailed_breakup') {
        this.router.navigate([event.actionType.redirectLink], { queryParams: { breakup: true } })
      }
      else if (event.actionType.action == 'summary_breakup') {
        this.router.navigate([event.actionType.redirectLink], { queryParams: { breakup: true } })
      }
      else if (event.actionType.action_name == 'summary_breakup' && event.actionType.action == 'custom') {

        if (this.filter != "" && this.filter != undefined) {
          this.router.navigate([event.actionType.redirectLink], {
            queryParams:
            {
              breakup: true,
              "filter": this.filter
            }
          }
          )
        }
        else {
          this.router.navigate([event.actionType.redirectLink], {
            queryParams:
            {
              breakup: true
            }
          }
          )

        }

      }
      else {
        this.router.navigate([event.actionType.redirectLink])
      }
    }
  }

  onBulkActionClicked(action_obj) {
    this.loader.showSpinner();
    var menuObj;
    if (typeof action_obj.action == "string") {
      menuObj = { actionType: JSON.parse(JSON.stringify(action_obj)).items, data: {} };
      if (menuObj.actionType.file_data.gridInfo != null) {
        console.log(" menuObj.actionType.file_data.gridInfo", menuObj.actionType.file_data.gridInfo)
        menuObj.actionType.file_data.gridInfo.forEach(element => {
          if (this.dynamicHeaders.includes(element.name)) {
            var expStr = "item."+element.name+ " >= 0 || item."+element.name+ "<0";
            var class_conditions = [
                {
                    "expression": expStr,
                    "class": "align-right"
                }
            ]
            element.class_conditions = btoa(JSON.stringify(class_conditions)),
            element.type = "specialArray",
            element.getterArrayKey = 'payment_detail',
            element.value = this.specailValues.includes(element.name)? "payment_reciept_no" :"amount",
            element.setterKey = "payment_mode_code";
            try {
              element.name = this.specailValues.includes(element.name)? element.name.split("payment_reciept_no")[0] :element.name;
            }catch(e) {}
          }
        })
      }
    }
    else {
      menuObj = { actionType: JSON.parse(JSON.stringify(action_obj)), data: {} };
      let gridInfo = []
      this.fields.fields.forEach(elem => {
        let obj;
        obj = { name: elem.name, heading: elem.heading, format: "", type: "" }
        if (this.dynamicHeaders.includes(elem.name)) {
          var expStr = "item."+elem.name+ " >= 0 || item."+elem.name+ "<0";
            var class_conditions = [
                {
                    "expression": expStr,
                    "class": "align-right"
                }
            ]
            obj.class_conditions = btoa(JSON.stringify(class_conditions)),
            obj.type = "specialArray",
            obj.getterArrayKey = 'payment_detail',
            obj.value = "amount",
            obj.setterKey = "payment_mode_code"
        }
        else if (elem.type == 'datetime') {
          obj.type = "datetime"
        } else if (elem.type == "composite") {
          obj.type = "composite";
          obj.format = btoa(elem.format);
        } 
        else if(elem.type=="array")
        {
          obj.type="array";
          obj.format = btoa(elem.format);
        }
        else
          obj.type = "string"
        gridInfo.push(obj)
      });
      let userArr = [];
      let userIdd = [];
      menuObj.actionType.items.forEach(element => {
        if (this.type == 'collection_detail') {
          userIdd.push(element.id);
        }
        else {
          userArr.push(element.userId);
        }
      });
      if (this.type == 'collection_detail') {
        menuObj.actionType.file_data = { gridInfo: gridInfo, file_type: 'pdf', action: 'print', userIdd: userIdd.join('#') }
      }
      else {
        menuObj.actionType.file_data = { gridInfo: gridInfo, file_type: 'pdf', action: 'print', userArr: userArr.join('#') }
      }
    }
    // if (this._currentData["archiveConfig"] != undefined) {
    //   var argsArchive = "archive_policy:" + this._currentData["archiveConfig"]["selected"]["id"];
    //   if (this._currentData["archiveConfig"]["selected"]["db_type"] != undefined) {
    //     argsArchive += ",archive_db_type:" + this._currentData["archiveConfig"]["selected"]["db_type"]
    //   }
    //   if (action_obj) {
    //     if (this._currentData["archiveConfig"]["selected"]["apply_on_summary"] != undefined && this._currentData["archiveConfig"]["selected"]["apply_on_summary"]) {
    //       if (gridData.args != undefined && gridData.args != "") {
    //         gridData.args = gridData.args + ',' + argsArchive;
    //       } else {
    //         gridData.args = argsArchive;
    //       }
    //     }
    //   } else {
    //     if (gridData.args != undefined && gridData.args != "") {
    //       gridData.args = gridData.args + ',' + argsArchive;
    //     } else {
    //       gridData.args = argsArchive;
    //     }
    // }

    // }
    let filterArr = [];
    if (this.selectedFilter)
      filterArr.push(this.selectedFilter)
    if (menuObj.actionType.file_data.userIdd) {
      filterArr.push('id:' + menuObj.actionType.file_data.userIdd)
    }
    if (menuObj.actionType.file_data.userArr) {
      filterArr.push('userId:' + menuObj.actionType.file_data.userArr)
    }
    if ((menuObj.actionType.items == undefined || (menuObj.actionType.items && menuObj.actionType.items.length <= 25)) && this.arch_Data != undefined && this.arch_Data.forceEndOfDay) {
      var gridData = {
        application: "misreports",
        filter: filterArr.join(','),
        projectionKeys: this.config.projectionKeys.toString(),
        page_size: this.pageSize != undefined ? this.pageSize : 10,
        queryId: this.apiResource.queryId,
        amount: '',
        args: "reportTemplateId:grid,downloadOnly:true,archive_policy:ARCHIVE,contentType:" + menuObj.actionType.file_data.file_type+",patientType:"+this.currentTab,
        // newPrint: menuObj.actionType.file_data.newPrint,
        template: "grid",
        search : this.searchs,
        search_columns : this.search_columns,
        contentType: menuObj.actionType.file_data.file_type,
        gridInfo: btoa(JSON.stringify(menuObj.actionType.file_data.gridInfo)),
        gridHeading: (this.type == 'cashier' ? 'Cashier Collection Summary' : (this.type == 'summary' ? 'User Wise Collection Summary' : (this.type == 'collection_detail' ? 'Cashier Collection Detail' : 'UHID Advance'))),
        download_summary: (this.response != undefined && this.response.config != undefined && this.response.config.download_summary != undefined) ? this.response.config.download_summary : false
      }
      gridData['filterPrintInfo'] = action_obj != undefined && action_obj.items != undefined && action_obj.items.file_data != undefined && action_obj.items.file_data.filterPrintInfo != undefined && action_obj.items.file_data.filterPrintInfo ? btoa(JSON.stringify(action_obj.items.file_data.filterPrintInfo)) : (this.filterPrintInfo ? btoa(JSON.stringify(this.filterPrintInfo)) : false);
      if (menuObj.actionType.file_data.userArr != undefined || menuObj.actionType.file_data.userIdd != undefined) { }
      else
        gridData['page_no'] = this.pageNumber != undefined ? this.pageNumber : 0
      if (menuObj.actionType.file_data && menuObj.actionType.file_data.actionType && menuObj.actionType.file_data.actionType == 'downloadAll') {
        gridData['page_size'] = 0;
      }
      if (menuObj.actionType.file_data.gridInfo != undefined) {
        let resource
        if(menuObj.actionType.file_data.actionType == 'downloadAll' || menuObj.actionType.file_data.actionType == 'downloadCSV')
        {
        this.resource__ = this.apiResource.dataResource ? this.apiResource.dataResource + "/download" : this.apiResource.resource + "/download";
        this.response_type="application/json";
        if (menuObj.actionType.file_data.actionType && ["downloadAll","downloadCSV"].indexOf(menuObj.actionType.file_data.actionType) > -1) {
          gridData.page_size=0;
        }
        if(menuObj.actionType.file_data.actionType  !=undefined && ["downloadCSV"].indexOf(menuObj.actionType.file_data.actionType )>-1){
          gridData.args = gridData.args +  ','+menuObj.actionType.file_data.actionType+':true';
        }
        }
        else
        {
          this.resource__ = this.apiResource.dataResource ? this.apiResource.dataResource + "/print" : this.apiResource.resource + "/print";
          if(menuObj.actionType.file_data.actionType  !=undefined && menuObj.actionType.file_data.actionType =="download"){
            gridData.args = gridData.args + ',downloadCSV:true';
            this.response_type= "application/text"
          } else {            
            this.response_type="blob"
          }
        }
        this.baseService.action(gridData, "", this.apiResource.application, this.resource__, "", { responseType: this.response_type,printApplication:true }).subscribe((data: any) => {
          if (data.errCode != undefined && data.errCode == -9) {
            //do nothing
          } else if(menuObj.actionType.file_data.actionType  !=undefined && menuObj.actionType.file_data.actionType =="download"){
            var fileName = (gridData.gridHeading != undefined) ? gridData.gridHeading : "Payment Collection";
            fileName += ".csv";
            let postObj = {
              contentType : menuObj.actionType.file_data.file_type,
              gridInfo : gridData.gridInfo,
              action : menuObj.actionType.file_data.action,
              args : gridData.args,
              queryId : gridData.queryId,
              amount : gridData.amount,
              filter : gridData.filter,
              search : this.searchs,
              search_columns : this.search_columns,
              template : gridData.template,
              page_size : gridData.page_size,
              filterPrintInfo : btoa(JSON.stringify(menuObj.actionType.file_data.filterPrintInfo)),
              gridHeading : gridData.gridHeading,
            }
            menuObj.actionType.file_data.postObj = postObj;
            menuObj.actionType.file_data.resource = this.resource__;
            if(this.filterPrintInfo != undefined)
            {
              postObj.filterPrintInfo = btoa(JSON.stringify(this.filterPrintInfo))
            }
            this.downloadService.formatData(data, menuObj.actionType.file_data, fileName);
          } else { 
            this.printService.handleFileReponse({ contentType: menuObj.actionType.file_data.file_type, key: 'Collection' }, menuObj.actionType.action.action ? menuObj.actionType.action.action : menuObj.actionType.action, data);
          }
         
          this.loader.hideSpinner();
        })
      } else {
        this.handleFile(menuObj.actionType, menuObj);
      }
    }
    else if (menuObj.actionType.items == undefined || (menuObj.actionType.items && menuObj.actionType.items.length <= 25)) {
      var gridData = {
        application: "misreports",
        filter: filterArr.join(','),
        projectionKeys: this.config.projectionKeys.toString(),
        page_size: this.pageSize != undefined ? this.pageSize : 10,
        queryId: this.apiResource.queryId,
        amount: btoa(JSON.stringify(this._currentData.amountData)),
        args: "reportTemplateId:grid,archive_policy:Default,contentType:" + menuObj.actionType.file_data.file_type,
        // newPrint: menuObj.actionType.file_data.newPrint,
        template: "grid",
        search : this.searchs,
        search_columns : this.search_columns,
        contentType: menuObj.actionType.file_data.file_type,
        gridInfo: btoa(JSON.stringify(menuObj.actionType.file_data.gridInfo)),
        gridHeading: (this.type == 'cashier' ? 'Cashier Collection Summary' : (this.type == 'summary' ? 'User Wise Collection Summary' : (this.type == 'collection_detail' ? 'Cashier Collection Detail' : 'UHID Advance'))),
        download_summary: (this.response != undefined && this.response.config != undefined && this.response.config.download_summary != undefined) ? this.response.config.download_summary : false
      }
      if(gridData.download_summary != undefined && gridData.download_summary){
        var amountData  = JSON.parse(JSON.stringify(this._currentData.amountData));
        var newAmountData = [];
        if(Array.isArray(amountData) && amountData.length>0){
          for (let index = 0; index < amountData.length; index++) {
            const element = amountData[index];
            element["key"] =element.key
            element["value"] = element.value
            newAmountData.push(element);
          }
        }
        if(menuObj.actionType.action != undefined && menuObj.actionType.action != "print"){
          gridData["amount"] =  btoa(JSON.stringify(newAmountData));
          menuObj.actionType.file_data.downloadSumary = true;
          menuObj.actionType.file_data.summaryInfo = newAmountData;
        }
      }
      gridData['filterPrintInfo'] = action_obj != undefined && action_obj.items != undefined && action_obj.items.file_data != undefined && action_obj.items.file_data.filterPrintInfo != undefined && action_obj.items.file_data.filterPrintInfo ? btoa(JSON.stringify(action_obj.items.file_data.filterPrintInfo)) : (this.filterPrintInfo ? btoa(JSON.stringify(this.filterPrintInfo)) : false);
      if (menuObj.actionType.file_data.userArr != undefined || menuObj.actionType.file_data.userIdd != undefined) { }
      else
        gridData['page_no'] = this.pageNumber != undefined ? this.pageNumber : 0
      if (menuObj.actionType.file_data && menuObj.actionType.file_data.actionType && menuObj.actionType.file_data.actionType == 'downloadAll') {
        gridData['page_size'] = 0;
      }
      if (menuObj.actionType.file_data.gridInfo != undefined) {
        let resource
        if(menuObj.actionType.file_data.actionType == 'downloadAll' || menuObj.actionType.file_data.actionType == 'downloadCSV')
        {
        this.resource__ = this.apiResource.dataResource ? this.apiResource.dataResource + "/download" : this.apiResource.resource + "/download";
        this.response_type="application/json";
        if (menuObj.actionType.file_data.actionType && ["downloadAll","downloadCSV"].indexOf(menuObj.actionType.file_data.actionType) > -1) {
          gridData.page_size=0;
        }
        if(menuObj.actionType.file_data.actionType  !=undefined && ["downloadCSV"].indexOf(menuObj.actionType.file_data.actionType )>-1){
          gridData.args = gridData.args +  ','+menuObj.actionType.file_data.actionType+':true';
        }
        }
        else
        {
          this.resource__ = this.apiResource.dataResource ? this.apiResource.dataResource + "/print" : this.apiResource.resource + "/print";
          if(menuObj.actionType.file_data.actionType  !=undefined && menuObj.actionType.file_data.actionType =="download"){
            gridData.args = gridData.args + ',downloadCSV:true';
            this.response_type= "application/text"
          } else {            
            this.response_type="blob"
          }
        }
        this.baseService.action(gridData, "", this.apiResource.application, this.resource__, "", { responseType: this.response_type,printApplication:true }).subscribe((data: any) => {
          if (data.errCode != undefined && data.errCode == -9) {
            //do nothing
          } else if(menuObj.actionType.file_data.actionType  !=undefined && menuObj.actionType.file_data.actionType =="download"){
            var fileName = (gridData.gridHeading != undefined) ? gridData.gridHeading : "Payment Collection";
            fileName += ".csv";
            let postObj = {
              contentType : menuObj.actionType.file_data.file_type,
              gridInfo : gridData.gridInfo,
              action : menuObj.actionType.file_data.action,
              args : gridData.args,
              queryId : gridData.queryId,
              amount : gridData.amount,
              filter : gridData.filter,
              template : gridData.template,
              page_size : gridData.page_size,
              search : this.searchs,
              search_columns : this.search_columns,
              filterPrintInfo : btoa(JSON.stringify(menuObj.actionType.file_data.filterPrintInfo)),
              gridHeading : gridData.gridHeading,
            }
            menuObj.actionType.file_data.postObj = postObj;
            menuObj.actionType.file_data.resource = this.resource__;
            if(this.filterPrintInfo != undefined)
            {
              postObj.filterPrintInfo = btoa(JSON.stringify(this.filterPrintInfo))
            }
            this.downloadService.formatData(data, menuObj.actionType.file_data, fileName);
          } else { 
            this.printService.handleFileReponse({ contentType: menuObj.actionType.file_data.file_type, key: 'Collection' }, menuObj.actionType.action.action ? menuObj.actionType.action.action : menuObj.actionType.action, data);
          }
         
          this.loader.hideSpinner();
        })
      } else {
        this.handleFile(menuObj.actionType, menuObj);
      }
    }
    if (menuObj.actionType.items && menuObj.actionType.items.length > 25) {
      this.alertService.error('Selective print is not allowed for more than 25 items.')
      this.loader.hideSpinner()
    }

  }
  applyArchivePoicy(gridData, isSummary) {
    this.callGRID=true;
    if (this._currentData["archiveConfig"] != undefined) {
      var argsArchive = "archive_policy:" + this._currentData["archiveConfig"]["selected"]["id"];
      if (this._currentData["archiveConfig"]["selected"]["db_type"] != undefined) {
        argsArchive += ",archive_db_type:" + this._currentData["archiveConfig"]["selected"]["db_type"]
      }
      if (isSummary) {
        if (this._currentData["archiveConfig"]["selected"]["apply_on_summary"] != undefined && this._currentData["archiveConfig"]["selected"]["apply_on_summary"]) {
          if (gridData && gridData.args != undefined && gridData.args != "") {
            gridData.args = gridData.args + ',' + argsArchive;
          } else {
            if(gridData)
            gridData.args = argsArchive;
          }
        }
      } else {
        if (gridData &&gridData.args != undefined && gridData.args != "") {
          gridData.args = gridData.args + ',' + argsArchive;
        } else {
          if(gridData)
          gridData.args = argsArchive;
        }
      }

    }
  }

  search(event) {
    console.log("search=", event)
    let obj;
    var gridData = JSON.parse(JSON.stringify(this.newDataList));//making a clone
    if (this.type == 'summary')
      obj = { search_columns: event.key, search: event.value, filter: this.selectedFilter ? this.selectedFilter : '', page_size: 10, query_id: this.apiResource.queryId }
    else
    {
      obj = { search_columns: event.key, searchColumns: event.key , search: event.value, searchLabel: event.label, filter: this.selectedFilter ? this.selectedFilter : '', page_size: 10, query_id: this.apiResource.queryId }
    this.search_columns = event.key
    this.searchColumns = event.key 
    this.searchs =event.value
    this.searchLabel = event.label
    }
    // if (this.type == 'summary' || this.type == 'detail') {
    //   if (this.currentTab != 'all') {
    //     obj.filter = obj.filter + ",patientType:" + this.currentTab
    //   }
    // }
    // this.selectedFilter = obj.filter
    // }
    // this.newDataList = undefined;
    this.baseService.getData(obj, "", this.apiResource.dataResource ? this.apiResource.dataResource : this.apiResource.resource, this.apiResource.application).subscribe(
      (data: any) => {
        if (this.fields) {
          if (this.fields.amountResource) {
            this.fields['resFromGrid'] = data;
            this.fields.amountCall = false;
      
            if (data.search != undefined && data.search) {
              this.fields['hideViewSummary'] = true;
            }
            else {
              this.fields['hideViewSummary'] = false;
            }
          } 
        }
        if (this.fields.amountResource && this.fields.amountResource.datasource)
          this.getAmountApiCall()
        console.log("dtata ->", data)
        data.resource.forEach(element => {
          this.headerList.forEach(header => {
            element[header.name] = 0;
          });
          if (element.payment_detail) {
            element.payment_detail.forEach(subelement => {
              if (subelement.payment_mode_code != "")
                element[subelement.payment_mode_code] = subelement.amount
              if (subelement.payment_mode_code != "")
                element[subelement.payment_mode_code+"payment_reciept_no"] = subelement.payment_reciept_no  
            });
          }
        })
        this.newDataList = data;
      })
  }
  handleFile(action, obj, callback = null) {
    this.loader.stophideSpinner(true);
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
      fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : this.apiResource.resource;
      fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : this.selectedFilter;
      fileObj.filterPrintInfo  = action != undefined && action.file_data != undefined && action.file_data.filterPrintInfo != undefined && action.file_data.filterPrintInfo ? btoa(JSON.stringify(action.file_data.filterPrintInfo)) : (this.filterPrintInfo ? btoa(JSON.stringify(this.filterPrintInfo)) : false);

      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args) {
        fileObj.args = fileObj.args + ",patientType:"+this.currentTab+ ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : "");
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
        fileObj.args = fileObj.args + ",patientType:"+this.currentTab+",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      this.baseService.handleFile(fileObj, async (fileData) => {
        this.loader.stophideSpinner(false);
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      }
        // , (error) => {
        //   this.loader.hideSpinner();
        //   this.alerts.error('API error');
        //   if (callback) {
        //     callback(false);
        //   }
        // }
      );
    } else {
      this.loader.stophideSpinner(false);
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }
}
